<template>
    <div class="slide-show" v-cloak>
        <slider :items="items" :config="config">
            <template v-slot:body="{ item, index }">
                <slide
                    :key="index"
                    :overlay="overlay"
                    :paths="{
                        xlarge: item.xLargeFileUrl,
                        large: item.largeFileUrl,
                        medium: item.mediumFileUrl,
                        small: item.smallFileUrl
                    }"
                >
                    <div class="caption" v-html="item.body"></div>
                </slide>
            </template>
            <template v-slot:navigation v-if="items.length > 1">
                <slot name="navigation">
                    <div class="swiper-pagination"></div>
                </slot>
            </template>
        </slider>
    </div>
</template>
<script>
    import Slider from '../Slider';
    import Slide from './Slide';
    export default {
        components: { Slider, Slide },
        props: {
            items: {
                type: Array,
                default: () => []
            },
            config: {
                type: Object,
                default: () => { return {} }
            },
            overlay: {
                type: Boolean,
                default: false
            }
        }
    }
</script>